export function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
    return resultSoFar || dataTransfer.getData(typeToTry);
  }, '');
  return result != null ? result : defaultValue;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-html5-backend/dist/esm/NativeDragSources/getDataFromDataTransfer.js
// module id = 905
// module chunks = 4